import React from 'react';
import './VolumeRange.css';
import Slider from 'react-rangeslider'
import {HiOutlineVolumeUp} from 'react-icons/hi'
import cssClasses from './VolumeRange.css'

const volumeRange = (props) => {
  return (
      <div className={cssClasses.VolumeRange}>
          <h3 className="volumeUp"><HiOutlineVolumeUp /></h3>
          <Slider
            min={0}
            max={100}
            step={1}
            value={props.volume}
            orientation="vertical"
            onChange={props.volumeChange}
        />
      </div>
  );

}

export default volumeRange;